import React, { useContext } from "react";
import {
  useMediaQuery,
  IconButton,
  Button,
  Avatar,
  Box,
  Typography,
} from "@mui/material";
import { withRouter } from "react-router";
import { AccountCircle } from "@mui/icons-material";

import { AuthContext } from "../Home";

//Account Button
//Modern implementation with enhanced desktop and mobile views
function AccountButton(props) {
  const isMobile = useMediaQuery("(max-width:600px)");

  const Auth = useContext(AuthContext);

  // Get user initials for avatar
  const getUserInitials = () => {
    if (Auth.user && Auth.user.vorname && Auth.user.nachname) {
      return `${Auth.user.vorname.charAt(0)}${Auth.user.nachname.charAt(0)}`;
    }
    return "U";
  };

  // Mobile version - compact icon button
  if (isMobile) {
    return (
      <IconButton
        aria-label="account"
        onClick={() => props.history.push("/konto")}
        color="inherit"
        sx={{
          p: 1,
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        }}
      >
        <AccountCircle />
      </IconButton>
    );
  }

  // Desktop version - enhanced button with avatar and text
  return (
    <Button
      onClick={() => props.history.push("/konto")}
      color="inherit"
      startIcon={
        <Avatar
          sx={{
            width: 28,
            height: 28,
            fontSize: "0.875rem",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            color: "inherit",
          }}
        >
          {getUserInitials()}
        </Avatar>
      }
      sx={{
        textTransform: "none",
        borderRadius: 2,
        px: 2,
        py: 0.5,
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        },
        transition: "all 0.2s ease-in-out",
      }}
    >
      <Box sx={{ ml: 1, textAlign: "left" }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            lineHeight: 1.2,
            color: "inherit",
          }}
        >
          {Auth.user.vorname} {Auth.user.nachname}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            opacity: 0.8,
            lineHeight: 1,
            color: "inherit",
          }}
        >
          Konto verwalten
        </Typography>
      </Box>
    </Button>
  );
}

export default withRouter(AccountButton);
